import { Fragment } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface PageBreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const PageBreadcrumbs = ({ items }: PageBreadcrumbsProps) => {
  if (!items.length) return null;

  return (
    <nav aria-label="Fil d'Ariane" className="flex flex-wrap items-center gap-1 text-xs sm:text-sm text-muted-foreground mb-3 sm:mb-4">
      {items.map((item, index) => (
        <Fragment key={`${item.path}-${index}`}>
          {index > 0 && <ChevronRight className="h-3 w-3 shrink-0 opacity-50" />}
          {index === items.length - 1 ? (
            <span className="text-foreground font-medium truncate">{item.label}</span>
          ) : (
            <Link to={item.path} className="hover:text-[#23486a] transition-colors truncate">
              {item.label}
            </Link>
          )}
        </Fragment>
      ))}
    </nav>
  );
};
